import "./installApp.js";
import "./styles/main.css";
import { Router } from "./shared/router/Router.js";
import { AuthService } from "./shared/services/AuthService.js";

const initApp = async() => {
  // Vuelta del proveedor de ingreso externo (#access=...): se canjea antes de rutear
  await AuthService.capturarIngresoExterno();
  await AuthService.checkAuth(); // limpia una sesión vencida antes del primer render
  const router = new Router();
  router.init();
};

document.addEventListener("DOMContentLoaded", initApp);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  navigator.serviceWorker.register("/sw.js").catch(() => {});
}
